{
  "longPressMessage": "Prima continuamente ou prima Alt + Seta Para Baixo para abrir o menu"
}
